import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export const getDiscordAuthURL = () => {
  const domain = window.location.host.includes("localhost")
    ? `http://${window.location.host}`
    : `https://${window.location.hostname}`;

  const functionURL =
    "https://europe-west1-spike-ba886.cloudfunctions.net/discordAuth";
  const encoded = encodeURIComponent(functionURL);

  const discordPublicCode =
    brand.tenantId === "elgiganten-9u2oj"
      ? "1290248355057766423"
      : "1336964641171177482";

  return `https://discord.com/oauth2/authorize?client_id=${discordPublicCode}&response_type=code&redirect_uri=${encoded}&scope=identify+email+guilds.join&state=${domain}/discord-auth`;
};
